import {
  ACTION_ARGS,
  Arg,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  Metadata,
  pick,
} from '../../../../utils/spds/metadata';
import { FLEX_START } from '../../../../utils/spds/constants/css-layout';
import { on } from '@ember/modifier';
import GhostButton from '../../action/button/ghost.gjs';
import Super from '../../core/base.gjs';
import styles from './trigger.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

const METADATA = Metadata.define({
  description: 'Trigger button for Accordion component',
  extends: [
    pick(ACTION_ARGS, ['onClick']),
    pick(COMPONENT_STATE_ARGS, [
      { name: 'disabled', private: true },
      { name: 'open', private: true },
    ]),
    pick(CONTAINER_ARGS, ['reverse']),
    pick(CONTENT_ARGS, [
      { name: 'icon', default: 'dropdown-caret', description: 'Icon to display in trigger' },
    ]),
    pick(FLEX_ARGS, [
      'alignSelf',
      { name: 'gap', default: '12px' },
      { name: 'justifyContent', default: FLEX_START },
    ]),
  ],
  meta: {
    contentContainerId: Arg.string({
      description:
        'ID of the content container this trigger controls (set by the parent accordion)',
      private: true,
    }),
  },
  name: 'Accordion Trigger',
});

export default class SpdsContainerAccordionTrigger extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-container-accordion-trigger';
  classesToMap = ['open'];
  styles = styles;

  get expanded() {
    return `${this.args.open}`;
  }

  get gap() {
    return this.argOrDefault('gap');
  }

  get icon() {
    return this.argOrDefault('icon');
  }

  get justifyContent() {
    return this.argOrDefault('justifyContent');
  }

  <template>
    <GhostButton
      @alignSelf={{@alignSelf}}
      @disabled={{@disabled}}
      @gap={{this.gap}}
      @id={{this.id}}
      @justifyContent={{this.justifyContent}}
      @reverse={{@reverse}}
      class={{this.classes}}
      data-test-spds-container-accordion-trigger
      {{on "click" @onClick}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      aria-controls={{@contentContainerId}}
      aria-expanded={{this.expanded}}
      ...attributes
    >
      {{svgJar
        this.icon
        class="spds-container-accordion-trigger-icon"
        data-test-spds-container-accordion-trigger-icon=""
      }}
      {{yield}}
    </GhostButton>
  </template>
}

export const ACCORDION_TRIGGER_METADATA = SpdsContainerAccordionTrigger.metadata;
